export default __webpack_public_path__ + "static/media/Terms&Condition.a091b3fd.pdf";